import React, { memo, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Stack,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Chip,
  CircularProgress
} from 'investira.react.components';
import { BaseTemplate } from '../../components/templates';
import { PessoaImage } from '../../components/molecules';
import withMessage from '../../hoc/withMessage';
import withResponseHandling from '../../hoc/withResponseHandling';
import { useAvaliacoesContext } from '../../contexts/AvaliacoesContext';
import services from '../../services';

const AvaliacoesWaiting = memo(props => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, actions } = useAvaliacoesContext();

  const [loading, setLoading] = useState(true);
  const [avaliacaoData, setAvaliacaoData] = useState(null);

  useEffect(() => {
    if (id) {
      services.avaliacoes.read(
        id,
        rRes => {
          setAvaliacaoData(rRes.data);
        },
        rErr => {
          props.responseErrorHandling(rErr);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [id]);

  const gestor = avaliacaoData?.gestor || state.gestor || {};
  const { logo_pessoa_id, pessoa_fantasia } = gestor;
  const emailResponsavel = avaliacaoData?.gestor_email || 'E-mail não informado';
  const displayName = pessoa_fantasia;

  if (loading) {
    return (
      <BaseTemplate title={'Solicitação Enviada'} subtitle={'Nova Avaliação'} maxWidth={'md'}>
        <Stack alignItems="center" justifyContent="center" py={8}>
          <CircularProgress />
        </Stack>
      </BaseTemplate>
    );
  }

  return (
    <BaseTemplate title={'Solicitação Enviada'} subtitle={'Nova Avaliação'} maxWidth={'md'}>
      <Stack spacing={2}>
        <Card>
          <CardContent>
            <Stack gap={2}>
              <Stack spacing={1.5}>
                <PessoaImage logoPessoaId={logo_pessoa_id} alt={displayName} size={50} />
                <Typography variant="h6" color="textPrimary">
                  {displayName}
                </Typography>
              </Stack>

              <Stack>
                <Typography variant="body1" color="textPrimary">
                  Enviamos a solicitação para o e-mail:{' '}
                  <Typography component="span" sx={{ fontWeight: 600 }}>
                    {emailResponsavel}
                  </Typography>
                </Typography>
              </Stack>
              <Divider />
              <Stack direction="row">
                <Chip
                  label="Enviado"
                  color="warning"
                  sx={{ px: 1 }}
                  size="small"
                  variant="contained"
                />
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            variant="contained"
            onClick={() => {
              actions.handleResetState();
              navigate('/avaliacoes');
            }}>
            Voltar para Avaliações
          </Button>
        </Stack>
      </Stack>
    </BaseTemplate>
  );
});

AvaliacoesWaiting.displayName = 'AvaliacoesWaiting';

export default withMessage(withResponseHandling(AvaliacoesWaiting));
